import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DEFAULT_EVENT_SIZE } from "src/constants/size";
import { EventData } from "src/types/api";

export type InitialState = {
  eventType: number | undefined;
  events: EventData[];
  searchEvenet: string;
  seacrhValue: string;
  eventFilterSize: number;
};

const initialState: InitialState = {
  eventType: undefined,
  events: [],
  searchEvenet: "",
  seacrhValue: "",
  eventFilterSize: DEFAULT_EVENT_SIZE,
};

export const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setEventType: (state, action: PayloadAction<number | undefined>) => {
      state.eventType = action.payload;
    },
    setEvents: (state, action: PayloadAction<EventData[]>) => {
      state.events = action.payload;
    },
    setSearchEvent: (state, action: PayloadAction<string>) => {
      state.searchEvenet = action.payload;
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.seacrhValue = action.payload;
    },
    setEvenetFilterSize: (state, action: PayloadAction<number>) => {
      state.eventFilterSize = action.payload;
    },
  },
});

export const {
  setEventType,
  setEvents,
  setSearchEvent,
  setSearchValue,
  setEvenetFilterSize,
} = eventsSlice.actions;

export default eventsSlice.reducer;
